import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  Row,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsCopy } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { myBusinessUpdate } from "../../Redux/Settings/myBusiness/actions";

let holidaysData = {
  new_year: { name: "New Year's Day", date: "2023-01-01" },
  memorial_day: { name: "Memorial Day", date: "2023-05-29" },
  independence_day: { name: "Independence Day", date: "2023-07-04" },
  labor_day: { name: "Labor Day", date: "2023-09-04" },
  thanksgiving: { name: "Thanksgiving", date: "2023-11-23" },
  martin_luther_king_day: {
    name: "Martin Luther King Day",
    date: "2023-01-16",
  },
  president_day: { name: "President's Day", date: "2023-02-20" },
  good_friday: { name: "Good Friday", date: "2023-04-07" },
  juneteenth: { name: "Juneteenth", date: "2023-06-19" },
  columbus_day: { name: "Columbus Day", date: "2023-10-09" },
  veterans_day: { name: "Veterans Day", date: "2023-11-11" },
  day_after_thanksgiving: {
    name: "Day After Thanksgiving",
    date: "2023-11-24",
  },
  christmas_eve: { name: "Christmas Eve", date: "2023-12-24" },
  new_year_eve: { name: "New Year's Eve", date: "2023-12-31" },
};
const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];

const OperationalHours = () => {
    const [customHoliday, setCustomHoliday] = useState("");
    const [customDate, setCustomDate] = useState(new Date());
    const dispatch = useDispatch();
    const businessData = useSelector(state => state.myBusinessReducer.data)
    const user = useSelector(state => state.authReducer.data)
    const initialSelectedHolidays = businessData?.hoursOfOperation?.holidays
        ? Object.keys(holidaysData).filter((holiday) =>
            Object.keys(businessData.hoursOfOperation.holidays).includes(holiday)
        )
        : [];
    const formatCustomDate = (dateString) => {
        const [month, day] = dateString.split(' ');
        const numericDay = day.replace(/\D/g, ''); // Remove non-numeric characters
        const monthNumber = new Date(Date.parse(month + " 1, 2000")).getMonth() + 1;
        const formattedDate = new Date().getFullYear() + '-' + monthNumber.toString().padStart(2, '0') + '-' + numericDay.padStart(2, '0');
        return formattedDate;
    };
    const initialCustomHolidays = businessData?.hoursOfOperation?.holidays
        ? Object.keys(businessData.hoursOfOperation.holidays)
            .filter((holiday) => !Object.keys(holidaysData).includes(holiday))
            .reduce((customHolidaysObj, customHoliday) => {
                const name = customHoliday.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
                const date = formatCustomDate(businessData.hoursOfOperation.holidays[customHoliday]);

                customHolidaysObj[customHoliday] = {
                    name: name,
                    date: date,
                };

                return customHolidaysObj;
            }, {})
        : {};

    const [selectedHolidays, setSelectedHolidays] = useState([
        ...initialSelectedHolidays,
        ...Object.keys(initialCustomHolidays),
    ]);


    const [customHolidays, setCustomHolidays] = useState(initialCustomHolidays);
    const [finalHolidayData, setFinalHolidayData] = useState(businessData.hoursOfOperation.holidays);


    useEffect(() => {
         holidaysData = {
            ...holidaysData,
            ...customHolidays,
        };


    }, []);


    useEffect(() => {
        setSelectAll(selectedHolidays.length === Object.keys(holidaysData).length);
    }, [selectedHolidays]);
    const convertToFormattedWorkingHours = (workingHours) => {
        const capitalizeFirstLetter = (string) => {
            return string.charAt(0).toUpperCase() + string.slice(1);
        };
        const daysOfWeek = Object.keys(workingHours);
        return daysOfWeek.reduce((result, day) => {
            if (workingHours[day] === "Off-Day") {
                result[capitalizeFirstLetter(day)] = "Off-Day";
                return result;
            }
            const [start, end] = workingHours[day].split('-');

            result[capitalizeFirstLetter(day)] = {
                start: convertTo24HourFormat(start),
                end: convertTo24HourFormat(end),
            };
            if (result[capitalizeFirstLetter(day)].start === "00:00" &&
                result[capitalizeFirstLetter(day)].end === "00:00") {
                result[capitalizeFirstLetter(day)] = {};
            }
            return result;
        }, {});
    };

    const convertTo24HourFormat = (time) => {
        const [hour, minute] = time?.replace(/[^\d:]/g, '').split(':');
        const period = time?.includes('pm') ? 'PM' : 'AM';
        return period === 'PM' ? `${parseInt(hour, 10) + 12}:${minute}` : `${hour}:${minute}`;
    };

    const formattedWorkingHours = convertToFormattedWorkingHours(businessData?.hoursOfOperation?.days);

    useEffect(() => {
        setSelectAll(selectedHolidays.length === Object.keys(holidaysData).length);
    }, [selectedHolidays]);

    const [selectAll, setSelectAll] = useState(false);

    const formatDate = (date) => {
        const options = { day: "numeric", month: "short" };
        return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
    };

    const handleToggleAll = () => {
        const allHolidays = Object.keys(holidaysData);
        const updatedHolidays =
            selectedHolidays.length === allHolidays.length ? [] : allHolidays;

        setSelectedHolidays(updatedHolidays);

        const finalHolidaysData = {};
        updatedHolidays.forEach((selectedHoliday) => {
            if (holidaysData[selectedHoliday]) {
                // Predefined holidays
                const { name, date } = holidaysData[selectedHoliday];
                finalHolidaysData[selectedHoliday] = formatDate(date);
            } else {
                // Custom added holidays
                const customHolidayData = holidaysData[selectedHoliday];
                finalHolidaysData[selectedHoliday] = formatDate(customHolidayData.date);
            }
        });

        setFinalHolidayData(finalHolidaysData);
    };

    const handleToggleHoliday = (holiday) => {
        const updatedHolidays = selectedHolidays.includes(holiday)
            ? selectedHolidays.filter((h) => h !== holiday)
            : [...selectedHolidays, holiday];

        setSelectedHolidays(updatedHolidays);

        const finalHolidaysData = {};
        updatedHolidays.forEach((selectedHoliday) => {
            if (holidaysData[selectedHoliday]) {
                // Predefined holidays
                const { name, date } = holidaysData[selectedHoliday];
                finalHolidaysData[selectedHoliday] = formatDate(date);
            } else {
                // Custom added holidays
                const customHolidayData = holidaysData[selectedHoliday];
                finalHolidaysData[selectedHoliday] = formatDate(customHolidayData.date);
            }
        });

        setFinalHolidayData(finalHolidaysData);
    };

    const handleAddCustomHoliday = () => {
        if (customHoliday.trim() !== "") {
            const customHolidayKey = customHoliday.toLowerCase().replace(/\s/g, "_");
            const customHolidayData = {
                name: customHoliday,
                date: customDate.toISOString().split("T")[0],
            };

            if (!selectedHolidays.includes(customHolidayKey)) {
                const updatedHolidays = [...selectedHolidays, customHolidayKey];
                setSelectedHolidays(updatedHolidays);

                holidaysData[customHolidayKey] = customHolidayData;

                setCustomHoliday("");
                setCustomDate(new Date());

                const finalHolidaysData = {};
                updatedHolidays.forEach((selectedHoliday) => {
                    if (holidaysData[selectedHoliday]) {
                        const { name, date } = holidaysData[selectedHoliday];
                        finalHolidaysData[selectedHoliday] = formatDate(date);
                    } else {
                        const customHolidayData = holidaysData[selectedHoliday];
                        finalHolidaysData[selectedHoliday] = formatDate(customHolidayData.date);
                    }
                });
                setFinalHolidayData(finalHolidaysData);
            }
        }
    };

    useEffect(() => {
        setSelectAll(selectedHolidays.length === Object.keys(holidaysData).length);
    }, [selectedHolidays]);


    const [selectedDays, setSelectedDays] = useState([0, 1, 2, 3, 4, 5, 6]);
    const [copyAllText, setCopyAll] = useState("custom-copy-text-blue");
    const [workingHours, setWorkingHours] = useState({
        Monday: formattedWorkingHours.Monday,
        Tuesday: formattedWorkingHours.Tuesday,
        Wednesday: formattedWorkingHours.Wednesday,
        Thursday: formattedWorkingHours.Thursday,
        Friday: formattedWorkingHours.Friday,
        Saturday: formattedWorkingHours.Saturday,
        Sunday: formattedWorkingHours.Sunday || {},
    });

    const handleWorkingHoursChange = (day, field, value) => {
        setCopyAll("custom-copy-text-blue")
        setWorkingHours((prevHours) => ({
            ...prevHours,
            [day]: {
                ...prevHours[day],
                [field]: value,
            },
        }));
    };

    const handleCopyToAll = () => {
        const copiedHours = workingHours[daysOfWeek[selectedDays[0]]];
        selectedDays.forEach((dayIndex) => {
            const day = daysOfWeek[dayIndex];
            setWorkingHours((prevHours) => ({
                ...prevHours,
                [day]: { ...copiedHours },
            }));
        });
    };
    const formatDataForBackend = (workingHours) => {
        const daysOfWeek = Object.keys(workingHours);
        const formattedData = {};
        daysOfWeek.forEach((day) => {
            if (workingHours[day] === "Off-Day") {
                formattedData[day.toLowerCase()] = "Off-Day";
                return;
            }
            const startTime = workingHours[day].start;
            const endTime = workingHours[day].end;
            if (startTime === "" || endTime === "") {
                formattedData[day.toLowerCase()] = "Off-Day";
                return;
            }
            formattedData[day.toLowerCase()] = `${startTime}-${endTime}`;
        });
        return formattedData;
    };

    const renderHolidayButtons = () => {
        const allHolidays = Object.keys(holidaysData);
        return allHolidays.map((holiday) => {

            return (
                <Col key={holiday} md={4}>
                    <Button
                        variant={
                            selectedHolidays.includes(holiday) ? "info" : "outline-primary"
                        }
                        onClick={() => handleToggleHoliday(holiday)}
                        className="custom-color-2 w-100"
                    >
                        {customHolidays[holiday]?.name || holidaysData[holiday].name}
                    </Button>
                </Col>
            );
        });
    };

    const handleSaveChangesOperationalHours = async () => {
        const finalPayload = {
            "hoursOfOperation": {
                "days": formatDataForBackend(workingHours),
                "holidays" : businessData.hoursOfOperation.holidays,
            }
        };
        try {
            await myBusinessUpdate(dispatch, user.accountID, finalPayload);
        } catch (error) {
        }
    };

    const handleSaveChangesHolidays = async () => {
        const finalPayload = {
            "hoursOfOperation": {
                "days": businessData.hoursOfOperation.days,
                "holidays" : finalHolidayData,
            }
        };
        try {
            await myBusinessUpdate(dispatch, user.accountID, finalPayload);
        } catch (error) {
        }
    };

    return (
        <div style={{overflow:"auto",height:"83vh"}}>
            {/* Working Hours */}
            <Container className="border-bottom rounded" fluid>
                <h4 className="main-h4-tag-large mb-3">WORKING HOURS</h4>
                <Form className="TimeSelection mb-4">
                    {daysOfWeek.map((day, index) => (
                        <Row className="d-flex align-items-center" key={day}>
                            <Col md={2}>
                                <p className="mt-3 custom-style-settings-menu">{day}</p>
                            </Col>
                            <Col className="d-flex align-items-center" md={8}>
                                <Form.Group controlId={`${day}-start-time`} className="mr-3 w-100">
                                    <Form.Control
                                        type="time"
                                        value={workingHours[day].start}
                                        onChange={(e) =>
                                            handleWorkingHoursChange(day, "start", e.target.value)
                                        }
                                    />
                                </Form.Group>
                                <p className="mt-2 mr-3">to</p>
                                <Form.Group controlId={`${day}-end-time`} className="mr-3 w-100">
                                    <Form.Control
                                        type="time"
                                        value={workingHours[day].end}
                                        onChange={(e) =>
                                            handleWorkingHoursChange(day, "end", e.target.value)
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                {index === 0 && (
                                    <p
                                        onClick={handleCopyToAll}
                                        className={`${copyAllText} mt-3`}
                                    >
                                        <BsCopy size={15} className="mr-2"/>
                                        Copy to All
                                    </p>
                                )}
                            </Col>
                        </Row>
                    ))}
                </Form>

                <div className="d-flex justify-content-end align-items-end mt-3 mr-3">
                    <Button
                        variant="success"
                        onClick={handleSaveChangesOperationalHours}
                        className="custom-button"
                    >
                        Save Changes
                    </Button>
                </div>
            </Container>

            {/* Holidays Calendar */}
            <Container className="mt-3">
                <div className="d-flex justify-content-between align-items-center">
                    <h4 className="main-h4-tag-large">Holidays</h4>
                    <Button
                        variant="primary"
                        onClick={handleToggleAll}
                        className="custom-button"
                    >
                        {selectAll ? "Unselect All" : "Select All"}
                    </Button>
                </div>
                <Row>{renderHolidayButtons()}</Row>
                <div className="d-flex justify-content-center align-items-center">
                    <InputGroup className="w-75 mt-2">
                        <FormControl
                            placeholder="Enter custom holiday"
                            value={customHoliday}
                            onChange={(e) => setCustomHoliday(e.target.value)}
                            className="custom-input mr-3"
                        />
                    </InputGroup>
                    <DatePicker
                        selected={customDate}
                        onChange={(date) => setCustomDate(date)}
                        dateFormat="MMMM d, yyyy"
                        className="form-control custom-style-Datepicker"
                    />
                    <Button
                        variant="primary"
                        onClick={handleAddCustomHoliday}
                        className="custom-button ml-3"
                    >
                        Add
                    </Button>
                </div>
                <div className="d-flex justify-content-end align-items-end mt-3 mb-3">
                    <Button
                        variant="success"
                        onClick={handleSaveChangesHolidays}
                        className="custom-button"
                    >
                        Save Changes
                    </Button>
                </div>
            </Container>
        </div>
    );
};

export default OperationalHours;